import { h } from 'preact'; /** @jsx h */

import CTABlock from '../components/tommy/CTABlock/CTABlock';
import Content from '../components/tommy/Content/Content';
import FactsAccordion from '../components/tommy/FactsAccordion/FactsAccordion';
import FooterCTA from '../components/tommy/FooterCTA/FooterCTA';
import Heading from '../components/tommy/Heading/Heading';
import Hero from '../components/tommy/Hero/Hero';
import Image from '../components/tommy/Image/Image';
import ImageSwiper from '../components/tommy/ImageSwiper/ImageSwiper';
import Paragraph from '../components/tommy/Paragraph/Paragraph';
import ParallaxBanner from '../components/tommy/ParallaxBanner/ParallaxBanner';
import ParallaxContent from '../components/tommy/ParallaxBanner/ParallaxContent/ParallaxContent';
import Quote from '../components/tommy/Quote/Quote';
import ReadMore from '../components/tommy/ReadMore/ReadMore';
import ReadMoreItem from '../components/tommy/ReadMore/ReadMoreItem/ReadMoreItem';
import Section from '../components/tommy/Section/Section';
import StickyCTA from '../components/tommy/StickyCTA/StickyCTA';
import Video from '../components/tommy/Video/Video';

import '../styles/tommy/snoskredet-som-tok-tommy.scss';

const SnoskredetSomTokTommy = () => {
    // Swiper images array for ImageSwiper component
    const swiperImages = [
        {
            src: 'https://norskluftambulanse.no/wp-content/uploads/2024/02/tommy-haugen-sojdis-operasjon.jpg',
            alt: 'Tommy Haugen Søjdis i sengen på sykehuset.',
            caption:
                'Tommy hviler i sengen på sykehuset i Molde, der veien tilbake til skiene starter.'
        },
        {
            src: 'https://norskluftambulanse.no/wp-content/uploads/2024/02/tommy-haugen-sojdis-rehabilitering.jpg',
            alt: 'Tommy Haugen Søjdis på krykker med støtteskinne på benet.',
            caption:
                'Støttet av krykker og med benet i en støtteskinne, tar han små skritt på vei mot bedring på sykehuset.'
        },
        {
            src: 'https://norskluftambulanse.no/wp-content/uploads/2024/02/tommy-haugen-sojdis-sykehus.jpg',
            alt: 'Tommy Haugen Søjdis med prekestol i gangen på sykehuset.',
            caption:
                'Han har også en prekestol han kan lene seg på når han går i gangene på sykehuset.'
        }
    ];

    return (
        <div className="snoskred">
            <Hero
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/tommy-haugen-sojdis-hero-wide-scaled.jpg"
                alt="Tommy Haugen Søjdis (38) besøker helikopterbasen og mannskapet etter å ha blitt tatt av snøskred."
            >
                <Heading type="h1" className="hero-title">
                    <span className="hero-title-section">
                        <span>Snøskredet</span> som
                    </span>
                    <span className="hero-title-section">tok Tommy</span>
                </Heading>
            </Hero>

            <Section top color="off-white">
                <StickyCTA
                    title="Støtt oss nå"
                    text="1 av 10 oppdrag blir stoppet på grunn av dårlig vær. Med din støtte kan vi utvikle  løsninger som redder enda flere liv."
                    buttonText="Bli støttemedlem"
                    buttonCaption="Gi et fast valgfritt beløp"
                    link="/stottemedlem/"
                    orientation="right"
                />
                <Content width="small">
                    <Paragraph type="ingress">
                        Han skulle bare ta en kjapp ettermiddagstur før henting i barnehagen, men en
                        liten feilvurdering skulle få store konsekvenser for skikjøreren.
                    </Paragraph>
                    <Paragraph
                        type="byline"
                        text="Rolf Magnus W. Sæther"
                        photo="Rolf Magnus W. Sæther og privat"
                        video="Privat"
                    />
                    <Paragraph type="normal">
                        Dagen før ulykken hadde Tommy Haugen Søjdis (38) vært hjemme fra jobb med
                        spysyke og feber. Nå trengte småbarnsfaren litt luft, og en liten
                        ettermiddagstur kunne gjøre godt.
                    </Paragraph>
                    <Paragraph>
                        Den erfarne toppturkjøreren er bosatt i Isfjorden i Møre og Romsdal. Onsdag
                        6. april 2022 lokket fjellsidene med nysnø og pudder.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Jeg så at det hadde gått noen skred oppe i fjellsidene. Men jeg anså det
                        likevel som trygt å gå en tur dersom jeg senket ambisjonsnivået litt, sier
                        Søjdis.
                    </Quote>
                    <Paragraph>
                        Etter å ha tråkket opp ryggen mot Søre Klauva, skulle han kjøre ned
                        skråningen ned fra Steinberget og hjem. Her har terrenget stort sett mindre
                        enn 30 grader helling, som gir liten risiko for skred.
                    </Paragraph>
                </Content>
            </Section>

            <ParallaxBanner
                emergencyStripes="yellow"
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/hele-fjellsiden-losner.jpg"
                alt="Tommy Haugen Søjdis på fjelltur."
                orientation="right"
                color="off-white"
                colorTop="off-white"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="right">
                    <Heading type="h3" color="all-white" weight="600" className="no-margin">
                        Hele fjellsiden løsner
                    </Heading>
                    <Paragraph color="all-white" className="no-margin">
                        I stedet for å følge ryggen, velger Tommy å vende skituppene litt brattere
                        nedover i fallretningen, for å ta snarveien ned gjennom bjørkeskogen.
                    </Paragraph>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <StickyCTA
                    title="Støtt oss nå"
                    text="1 av 10 oppdrag blir stoppet på grunn av dårlig vær. Med din støtte kan vi utvikle  løsninger som redder enda flere liv."
                    buttonText="Bli støttemedlem"
                    buttonCaption="Gi et fast valgfritt beløp"
                    link="/stottemedlem/"
                    orientation="left"
                />

                <Content width="small">
                    <Paragraph>
                        Alt går etter planen, og snart ser han turens endepunkt ved langrennsløypa
                        nede i dalen.
                    </Paragraph>
                    <Paragraph type="background" color="secondary">
                        Det er nå han tar et <b>uheldig</b> valg.
                    </Paragraph>
                    <Paragraph>
                        I stedet for å følge ryggen, velger Tommy å vende skituppene litt brattere
                        nedover i fallretningen, for å ta snarveien ned gjennom bjørkeskogen.
                    </Paragraph>
                    <Paragraph>
                        Nå kommer han inn i en sørvendt, litt brattere skråning, der solen har gjort
                        snøen våt og tung.
                    </Paragraph>
                </Content>

                <Content width="small" type="video-float-right">
                    <Video
                        src="https://player.vimeo.com/video/910424213?h=21cc630018&autoplay=1&autopause=0&muted=1&loop=1&title=0&byline=0&portrait=0"
                        padding="177.78%"
                        caption="Video: Her ligger Tommy i snøskredet."
                    />
                    <div>
                        <Paragraph>
                            Plutselig begynner snøen å sprekke opp under han. Han blir kastet
                            bakover, og skyter fart nedover sammen med store mengder tung og våt
                            snø.
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Jeg rakk ikke å bli redd. Husker at jeg tenkte at jeg er alene. Hvem
                            skal redde meg? Jeg prøvde å kjøre ut av skredet, slik man ser på
                            skifilmer. Men det var umulig, med en halv meter snø i bevegelse over
                            skia.
                        </Quote>
                        <Paragraph>
                            Tommy kolliderer med flere trær. Han føres over 100 meter nedover.
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – I det ene øyeblikket var alt svart, fordi jeg ble trukket under
                            snømassene. I det neste øyeblikket ble det lyst når hodet var over
                            snøen. Så ble det mørkt igjen. Jeg hørte ett «knepp» av venstrebeinet
                            som gikk ut av ledd ved hofta.
                        </Quote>
                        <Heading>Telefonen er død</Heading>
                        <Paragraph>
                            Endelig stopper den ville ferden. Tommy sitter fast. Heldigvis er hode
                            og overkropp over snøen så han får puste.
                        </Paragraph>
                    </div>
                </Content>

                <Content width="small">
                    <Quote animation="fade-up" color="secondary">
                        – Jeg forsøkte å komme meg ut av skredet selv, men forsto raskt at jeg ikke
                        greide det. Da jeg prøvde å bevege venstrefoten, kjente jeg en voldsom
                        smerte.
                    </Quote>
                    <Paragraph type="background">
                        Han fisker frem mobilen for å sende melding hjem til samboeren og de to små
                        barna.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Jeg ville fortelle dem at jeg etter forholdene hadde det bra. Men mobilen
                        hadde fått noen slag og gått fullstendig i lås. Jeg var handlingslammet på
                        grunn av store smerter og redusert funksjon i beina. Men jeg visste at det
                        var mange folk på ski i nærheten og tenkte at jeg måtte forsøke å få kontakt
                        med noen, sier han.
                    </Quote>
                </Content>
            </Section>

            <ParallaxBanner
                emergencyStripes="yellow"
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/et-oyevitne.jpg"
                alt="Karoline Kaasa Dahl på fjelltur."
                orientation="right"
                color="off-white"
                colorTop="off-white"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="right">
                    <Heading type="h3" color="all-white" weight="600" className="no-margin">
                        Et øyenvitne
                    </Heading>
                    <Paragraph color="all-white" className="no-margin">
                        Karoline Kaasa Dahl har akkurat kjørt på ski ned fra fjelltoppen Kirketaket
                        da hun hører et voldsomt drønn oppe fra bjørkeskogen.
                    </Paragraph>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <StickyCTA
                    title="Støtt oss nå"
                    text="1 av 10 oppdrag blir stoppet på grunn av dårlig vær. Med din støtte kan vi utvikle  løsninger som redder enda flere liv."
                    buttonText="Bli støttemedlem"
                    buttonCaption="Gi et fast valgfritt beløp"
                    link="/stottemedlem/"
                    orientation="left"
                />

                <Content width="small">
                    <Quote animation="fade-up" color="secondary">
                        – Jeg snur meg og ser at omtrent hele sida på Steinberget har løsna og
                        kommer mot meg, sier Karoline, som selv er aktiv skikjører bosatt i
                        Isfjorden.
                    </Quote>
                    <Paragraph>
                        Hun ser at det er Tommy, som hun kjenner godt, som står halvveis oppreist,
                        innpakket i snø.
                    </Paragraph>
                    <Paragraph>
                        Karoline jobber som paramedisiner i ambulanse, og har trening i å vurdere
                        pasienter. Hun slår fast at han ikke har livstruende skader, men sterke
                        smerter i nedre del av kroppen. Snart kommer også to andre skikjørere og
                        hjelper til.
                    </Paragraph>
                    <Paragraph>
                        De prøver å flytte den skadde skikjøreren, men han skriker i smerte.
                    </Paragraph>
                </Content>

                <Content width="small" type="image-float-right">
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/02/tommy-haugen-sojdis-oddbjorn-tranvaag.jpg"
                        alt="Tommy Haugen Søjdis (t.v.) og Oddbjørn Tranvåg (t.h.) foran et helikopter inne på basen."
                        caption="Bilde: Tommy besøker redningsmann Oddbjørn Tranvåg på helikopterbasen i Ålesund."
                    />
                    <div>
                        <Heading>Mange skredhendelser</Heading>
                        <Paragraph>
                            Uka før påske ble hektisk for crewet som hadde vakt på
                            legehelikopterbasen i Ålesund. Pilot, lege og redningsmann måtte rykke
                            ut på flere skred formiddagen 6. april.
                        </Paragraph>
                        <Quote animation="fade-up" color="secondary">
                            – Jeg snur meg og ser at omtrent hele sida på Steinberget har løsna og
                            kommer mot meg, sier Karoline, som selv er aktiv skikjører bosatt i
                            Isfjorden.
                        </Quote>
                        <Paragraph>
                            På helikopterturen til Isfjorden ser de mye folk på de hvite toppene på
                            Møre. De ser også spor etter skred mange steder, og på sambandet hører
                            de at det pågår andre søk- og redningsaksjoner i området.
                        </Paragraph>
                    </div>
                </Content>

                <Content width="small">
                    <Paragraph>
                        Da de nærmer seg, ser de at andre skikjørere har kommet til for å hjelpe
                        Tommy.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Tid er avgjørende ved skredhendelser. Kameratredning er det viktigste for
                        å få pasienten ut av snømassene. Deretter må skadene behandles. Derfor drar
                        vi direkte til skred uten opphold for å kunne gi akuttmedisinsk hjelp så
                        raskt som mulig, sier redningsmannen.
                    </Quote>
                    <Heading>Flys ut av skredet</Heading>
                    <Quote animation="fade-up" color="secondary">
                        – Det var tydelig at Tommy hadde store smerter, så han fikk smertestillende,
                        først i nesen og så via kanyle. Jeg merket at han fikk skikkelig vondt da
                        jeg forsøkte å bevege hofteleddet. Da skjønte jeg at hofta var ute av ledd,
                        sier Tranvåg.
                    </Quote>
                    <Paragraph>
                        Redningsmenn i luftambulansetjenesten er utdannet helsepersonell, og kan
                        gjøre medisinske vurderinger av pasienten, assistert av luftambulanselegen.
                        Tommy legges på båre. Helikopteret løfter både pasient og redningsmann ut
                        fra rasområdet.
                    </Paragraph>
                    <Paragraph>
                        <b>På flyturen blir crewet kalt ut til enda et skred.</b> Derfor lander de
                        og overleverer Tommy til en ambulanse som kjører han til sykehuset i Molde,
                        der han blir mottatt av et kriseteam.
                    </Paragraph>
                    <Paragraph>
                        På sykehuset påvises det røket korsbånd og hofte ute av ledd. Den venstre
                        foten har gått ut og blitt vridd bakover i skredet.
                    </Paragraph>
                    <Paragraph>Nå venter operasjon og ett år med opptrening.</Paragraph>

                    <ImageSwiper images={swiperImages} />

                    <Heading>Lærdommen</Heading>
                    <Paragraph>
                        Snart to år senere er Tommy tilbake på ski. En snart 20 år gammel lidenskap
                        lar seg ikke temme. Han har reflektert over hva som gikk galt den dagen i
                        2022.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Jeg skulle bare ta en rask tur i kjente fjell, innimellom andre
                        forpliktelser. Derfor brukte jeg nok ikke like mye tid på å vurdere risikoen
                        som jeg burde ha gjort.
                    </Quote>
                    <Paragraph>
                        Tommy er svært takknemlig for alle som hjalp han, både skikjørerne,
                        redningspersonellet, ambulansen og sykehuset. Han tør nesten ikke tenke på
                        hvordan det hadde gått dersom det ikke hadde vært andre i nærheten.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Skikjøring vil alltid innebære en viss risiko, men i fremtiden vil jeg
                        ikke gå alene dersom jeg vurderer risikoen og skredfaren for stor for dette,
                        sier han.
                    </Quote>
                    <Paragraph>
                        Redningsmann Oddbjørn Tranvåg er ikke ute etter å dømme de som går på
                        toppturer og blir tatt av skred.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Det virker som om Tommy har tatt flere gode veivalg den dagen, men det
                        skal så lite til å bomme litt. Akkurat den dagen var den siden utrygg, men
                        det kan være helt supert å kjøre der nesten alle andre dager. Det er også
                        viktig å huske at det er mye folkehelse i å gå på toppturer og å være ute i
                        naturen, sier Tranvåg.
                    </Quote>

                    <FactsAccordion
                        title="Dette må du gjøre ved snøskred"
                        href="/dette-gjor-du-dersom-noen-blir-tatt-av-et-snoskred/"
                        linkText="Les mer om hva du må gjøre ved snøskred her"
                        borderColor="secondary"
                        bgColor="all-white"
                        btnColor="primary"
                        items={[
                            {
                                title: 'Varsle og søke',
                                text: 'Varsle raskt hvis du er alene, og om dere er flere, la en person varsle umiddelbart med informasjon om sted, antall savnede og om de har sender/mottaker. Ring politi eller helse for å gi din posisjon. Beveg deg raskt over skredområdet, bruk sender/mottaker, og søk etter savnede. Hvis signal ikke mottas, gjennomfør punktsøk med søkestang rundt gjenstander. Spred dere utover hvis dere er flere. Arbeid raskt og effektivt for å redde skredofrene i tidlig fase. Merk punktet hvor personen forsvant og stedet om mulig.'
                            },
                            {
                                title: 'Utnytt ventetiden',
                                text: 'Finner du ingen signaler på sender/mottaker og personen er ikke synlig, søk begrenset rundt funn av lette gjenstander som lue og votter. Personer vil sannsynligvis ligge høyere i skredet. Søk grundig i dette området før du prøver en fall-linje med søkestang. I gruppe, stå på linje med utstrakte armer, stikk søkestangen maks to meter ned, lag tre hull i rett linje, og gjenta. Ved funn, la søkestangen stå og start graving.'
                            },
                            {
                                title: 'Grav frem den skredtatte',
                                text: 'Grav ned langs søkestangen, og utvid gropen til en omvendt V for å få vekk snøen. Jobb raskt og effektivt med mål om å få hode ut fra snøen. Snakk til den skredtatte og se om du får kontakt. Kontroller at vedkommende puster og sjekk allmenntilstanden når personen er gravd ut. Puster ikke personen, start umiddelbart opp med <a href="/hjerte-og-lungeredning-hlr/">hjerte- lungeredning.</a>'
                            },
                            {
                                title: 'Pakk personen inn',
                                text: 'Personen vil være utsatt for nedkjøling. Puster pasienten, legg han på siden og beskytt mot kulda fra snøen. Legg noe isolerende under vedkommende. Her kan man bruke en tom sekk. Pakk personen inn med en ekstra jakke, vindsekk eller liknende.'
                            },
                            {
                                title: 'Tren på kameratredning',
                                text: 'Kameratredning er det som redder flest liv ved snøskred. Det er viktig å trene jevnlig på bruk av sender/mottaker, koble sammen og bruke søkestangen og plan for utgravning. Tenk gjennom mentalt hva du vil gjøre om uhellet er ute.'
                            }
                        ]}
                    />
                    <ReadMore title="Les mer om arbeidet vi gjør for å forbedre luftambulansetjenesten">
                        <ReadMoreItem
                            imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/forskning-1.jpg"
                            imageAlt="Stipendiat Ingrid Nygren Rognes på OUS Ullevål sykehus."
                            title="Vi forsker på områder som kan forbedre luftambulansetjenesten"
                            text="Vi ønsker at det medisinske tilbudet utenfor sykehus skal være best mulig – derfor forsker vi på områder som kan forbedre luftambulansetjenesten."
                            link="/forskning/"
                            linkText="Les mer om forkningen vår"
                        />
                        <ReadMoreItem
                            imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/forskning-2.jpg"
                            imageAlt="Utviklingshelikopteret går inn for landing."
                            title="Helikopter dedikert til forskning og utvikling"
                            text="Stiftelsen Norsk Luftambulanse har et eget utviklingshelikopter som er dedikert til forskning og utvikling."
                            link="/innovasjon/utviklingshelikoptret/"
                            linkText="Les mer om utviklingshelikopteret"
                        />
                    </ReadMore>
                </Content>
            </Section>

            <FooterCTA
                href="/stottemedlem/"
                linkText="<b>Bli støttemedlem</b><br/>Din støtte bidrar til å redde liv"
                color="primary"
                bgColor="off-white"
                textColor="all-black"
            />

            <Section color="off-white">
                <Content width="large">
                    <CTABlock
                        divider
                        color="secondary"
                        title="Det koster <b>ingenting</b> å være bedre forberedt"
                        innerTitle="Last ned Hjelp 113-appen"
                        bulletPoints={[
                            'Alle nødnumre på ett sted',
                            'Koordinatene der du befinner deg',
                            'Oversikt over hjertestartere i nærheten',
                            'Appen er helt gratis'
                        ]}
                        buttonText="Last ned Hjelp 113 her"
                        link="/hjelp/"
                        orientation="left"
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/Norsk-Luftambulanse_March-2020_Kyle-Meyr_HR0046-1-e1707218019954.jpg"
                        alt="Luftambulansepersonell tar hånd om pasient."
                    />
                    <CTABlock
                        color="secondary"
                        title="Støtt vårt <b>livsviktige</b> arbeid"
                        innerTitle="Din støtte redder liv"
                        bulletPoints={[
                            'Enkelt og kostnadsfritt',
                            'Bidra med et fast beløp hver måned',
                            'Valgritt beløp fra 100 kr/mnd',
                            'Avtalegiro, eFaktura, eller Vipps'
                        ]}
                        buttonText="Bli støttemedlem her"
                        link="/stottemedlem/"
                        orientation="right"
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2021/05/Norsk-Luftambulanse_January-2021_Kyle-Meyr_HR0007.jpg"
                        alt="Helikopterpilot skuer ut over landskapet fra cockpit."
                    />
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="small"></Content>
            </Section>
        </div>
    );
};

export default SnoskredetSomTokTommy;
